import { useQuery } from "react-query";
import { remoteKeys } from "../apis";
import { getConnectedPlatformsPaginated } from "../apis/connected-platforms";
import { PlatformConnection } from "../../types/tokens";
import { paginateAllConnectors } from "../utilities";

export const useGetConnectedPlatforms = ({
  linkTokenEndpoint,
  linkHeaders,
}: {
  linkTokenEndpoint: string;
  linkHeaders: Record<string, unknown>; 
}) => {
  const { data, isLoading } = useQuery<{ rows: PlatformConnection[], requestId?: number, isWhiteLabel?: boolean }>({
    queryKey: [remoteKeys.getConnectedPlatforms, linkTokenEndpoint],
    queryFn: async () => {
      const paginatedApiFunction = getConnectedPlatformsPaginated(linkTokenEndpoint, linkHeaders);
      
      try {
        // Try to use the pagination utility for page-based responses
        const result = await paginateAllConnectors(paginatedApiFunction, {
          limit: 100,
          maxConcurrentRequests: 3,
          maxRetries: 3
        });
        return result;
      } catch (error) {
        // Fallback: if pagination fails, try a single request (might be Token format)
        console.warn('Pagination failed, falling back to single request:', error);
        return await paginatedApiFunction(1, 100);
      }
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  // Handle different response structures
  const platforms: PlatformConnection[] = data?.rows || [];

  const requestId = data?.requestId;
  const isWhiteLabel = data?.isWhiteLabel;

  return { 
    data: platforms, 
    isLoading,
    requestId,
    isWhiteLabel
  };
};
